import { createApiRef } from "@backstage/core-plugin-api";
import type { FirefighterClient } from "@internal/backstage-plugin-firefighter-common";

/**
 * API reference for the Firefighter plugin
 *
 * @public
 */
export const firefighterApiRef = createApiRef<FirefighterClient>({
    id: "plugin.firefighter.service",
});
